import React from 'react';
import { useProductContext } from '../product-router';

/**
 * Displays the product when the product is marked as displayed
 */
export const ActiveProduct = ({
  children,
  id
}) => {
  const {
    getProduct
  } = useProductContext();
  const product = getProduct(id);
  if (!(product !== null && product !== void 0 && product.isDisplayed)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};